module.exports = __webpack_public_path__ + "static/media/who-we-are.5bd86a7a.png";